import React from "react";
import {useTranslation} from "react-i18next";
import AccessTicketOptionStatusPill
    from "pages/Front/Booking/BookingLogin/components/ReservationDetailComponents/AccessTicketOptionStatusPill";
import {driverName} from "utils/utility";
import {ReservationDriver} from "types/entities/ReservationDriver";
import {useAssignedItems} from "utils/hooks/useAssignedItems";
import FeatherIcon from "components/FeatherIcon";
import {useTypedSelector} from "helpers/reducers";

export const AccessTicketDriversAssignationStatusItem = (props: {children: React.ReactNode | React.ReactNode[]}) => {
    return <div className={"AccessTicketDriversAssignationStatusItem flex flex-row items-center justify-between gap-x-1.5"}>{props.children}</div>;
};

export const StatusCheck = (props: {children: React.ReactNode | React.ReactNode[]}) => {
    return <div className={"AccessTicketDriversAssignationStatusCheck basis-[80px] flex justify-center"}>{props.children}</div>;
};

export const AccessTicketDriversAssignationStatusItemSwitcher = (props: {reservationDriver: ReservationDriver; children: React.ReactNode}) => {
    const {t} = useTranslation();
    const user = useTypedSelector(state => state.bookingLoginState.user);
    const reservationDriver = props.reservationDriver;
    const isMainUser: boolean = user?.id === props?.reservationDriver?.driver?.id;
    const userHasBirthdateAndNickname: boolean = !!(props?.reservationDriver?.driver?.nickname && props?.reservationDriver?.driver?.birthdate);

    if (reservationDriver.invited_at === null || reservationDriver.is_invited === false) {
        return (
            <AccessTicketDriversAssignationStatusItem>
                <AccessTicketOptionStatusPill className={"bg-gray-200 !text-xs md:!text-[20px] md:!leading-normal font-medium"}>
                    <span>{reservationDriver.driver ? driverName(reservationDriver.driver) : "----"}</span>
                </AccessTicketOptionStatusPill>
                <div className={"grow-0 flex flex-row gap-x-3 items-center justify-end"}>
                    {props.children}
                    <StatusCheck>
                        {(isMainUser && userHasBirthdateAndNickname || !isMainUser)
                            ? (<FeatherIcon className={"size-[20px] md:size-[30px] text-arbo-green"} name={"check"} strokeWidth={2} />)
                            : (<FeatherIcon className={"size-[20px] md:size-[30px] text-arbo-amber"} name={"alert-circle"} strokeWidth={2} />)
                        }
                    </StatusCheck>
                </div>
            </AccessTicketDriversAssignationStatusItem>
        );
    }

    return (
        <AccessTicketDriversAssignationStatusItem>
            <AccessTicketOptionStatusPill className={"bg-arbo-yellow/50"}>
                <span>
                    {t("Invited")}: {reservationDriver.identifier}
                </span>
            </AccessTicketOptionStatusPill>
            <div className={"grow-0 flex flex-row gap-x-3 items-center justify-end"}>
                {props.children}
                <StatusCheck>
                    <FeatherIcon className={"size-[20px] md:size-[30px] text-arbo-yellow"} name={"clock"} strokeWidth={2} />
                </StatusCheck>
            </div>
        </AccessTicketDriversAssignationStatusItem>
    );
};

export const AccessTicketDriversAssignationStatusDriver = (props: {reservationDriver: ReservationDriver}) => {
    const {reservationDriverUpsellItems} = useAssignedItems(props.reservationDriver);

    return (
        <div className="AccessTicketDriversAssignationStatusDriver flex flex-col items-stretch justify-center w-full pl-[51px] md:pl-[81px] pr-[12px] md:pr-[16px] pt-[27px] md:pt-[33px] pb-[27px] md:pb-[33px]">
            <AccessTicketDriversAssignationStatusItemSwitcher reservationDriver={props.reservationDriver}>
                <span>
                    {reservationDriverUpsellItems.length > 0 && (
                        <FeatherIcon className={"size-[20px] md:size-[30px] text-[#F6BB06]"} name={"shopping-bag"} strokeWidth={2} />
                    )}
                </span>
            </AccessTicketDriversAssignationStatusItemSwitcher>
        </div>
    );
};
